/*
 * File: \src\service\data-rangers\index.js
 * Created Date: 2020-11-05 09:13:28
 * Author: gaozw
 * -----
 * Last Modified: 2020-11-05 12:03:23
 * Modified By: gaozw
 */
import DataRangers from './src/data-rangers'

const dataRanger = new DataRangers()
dataRanger.install = Vue => Vue.prototype.$_dataRanger = dataRanger

export default dataRanger
